import styled from 'styled-components';
import Typography from '../../Typography';
import { Link as LinkRouter } from '@reach/router'

export const Wrapper = styled.footer`
  color: #FFF;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Heading = styled.section`
  border-bottom: 1px solid #ccc;
  padding: 20px;
`

export const Logo = styled.div`
  img {
    filter: brightness(0) invert(1);
  }
`

export const Link = styled(LinkRouter)`
  font-family: 'ToyotaType Book';
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.05em;
  color: #fff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
export const Body = styled.section`
  padding: 20px;
  align-self: flex-start;
`

export const BodyHeading = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`

export const CopyRight = styled(Typography.BodySmall)``

export const Disclaimer =  styled(Typography.BodySmall)`
  a {
    color: #FFF;
    margin-left: 0;
    text-decoration: none;
    display: inline-block;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const Portfolios = styled.div`
  margin-bottom: 10px;
`

export const About = styled.div``

export const Title = styled.span`
  font-family: 'ToyotaType Book';
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.05em;
  font-weight: 900;
`

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  padding-right: 15px;
  column-count: 2;
`

export const ListItem = styled.li`
  font-family: 'ToyotaType Book';
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.05em;
`

